import { gql } from '@apollo/client';

export const DELETE_TRAINING_PHASE = gql`
    mutation deleteTrainingPhase($idPhase: ID!){
        deleteTrainingPhase(idPhase: $idPhase)
    }
`;
